<template>
  <ion-grid>
    <ion-row v-if="show === 'items'">
      <ion-col size="12" size-sm="12" size-md="6" size-lg="4" size-xl="2">
        <ion-button @click="goBack()">
          Terug
          <ion-icon slot="icon-only" name="arrow-round-back" size="large"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col
        size="12"
        size-sm="12"
        size-md="6"
        size-lg="4"
        size-xl="2"
        v-for="item in filteredItems"
        :key="item.id"
        @click="clickCard(item)"
      >
        <card
          :id="item.id"
          :color="item.color"
          :group="item.group"
          :spokenText="item.spokenText"
          :type="item.type"
          :image="item.image"
          :title="item.title"
        >
        </card>
      </ion-col>
    </ion-row>
  </ion-grid>
</template>
<style lang="scss" scoped></style>
<script>
import { firebase, storage } from "@/firebase/firebase";
import Card from "../components/Card";

export default {
  name: "items",
  props: ["mode", "image"],
  components: {
    Card
  },
  data() {
    return {
      items: [],
      show: "groups",
      showGroupID: "",
      lastIDs: []
    };
  },
  computed: {
    filteredItems() {
      return this.$store.state.items.filter(item => {
        if (
          (this.show === "groups" && item.group === null) ||
          (this.show === "groups" && item.group === "")
        ) {
          return item;
        } else if (this.show === "items" && item.group === this.showGroupID) {
          return item;
        }
      });
    }
  },
  methods: {
    async getItems() {
      let itemsRef = await firebase
        .firestore()
        .collection("users")
        .doc(firebase.auth().currentUser.uid)
        .collection("items");
      itemsRef.onSnapshot(snap => {
        this.$store.commit("emptyItems");
        this.items = [];
        snap.forEach(doc => {
          console.log("Current data: ", doc.data());
          let item = doc.data();
          item.id = doc.id;
          // this.items.push(item);
          this.$store.dispatch("storeItem", item);
        });
      });
    },
    goToAddItem() {
      this.$router.push({ name: "addItem" });
    },
    goBack() {
      if (this.showGroupID) {
        this.lastIDs.pop();
        this.show = "items";
        this.showGroupID = this.lastIDs[this.lastIDs.length - 2];
        if (this.showGroupID === undefined) {
          this.show = "groups";
        }
      } else {
        this.show = "groups";
      }
    },
    clickCard(item) {
      let id = item.id;
      if (this.mode === "edit") {
        if (item.type === "group" || item.type === "groep") {
          this.presentGroupActionSheet(item);
        } else if (item.type === "item") {
          this.presentItemActionSheet(item);
        }
      } else {
        if (item.type === "group" || item.type === "groep") {
          this.show = "items";
          this.showGroupID = id;
          this.lastIDs.push(this.showGroupID);
        } else if (item.type === "item") {
          this.playSound(item);
        }
      }
    },
    playSound(item) {
      let speak = item.spokenText;
      window.responsiveVoice.speak(speak, "Dutch Female");
    },
    presentItemActionSheet(item) {
      let id = item.id;

      return this.$ionic.actionSheetController
        .create({
          header: "Bewerk",
          buttons: [
            {
              text: "Bewerk",
              icon: "create",
              handler: () => {
                let path = "/edit/" + id;
                this.$router.push({ path });
                console.log("Edit clicked: " + id);
              }
            },
            {
              text: "Voorbeeld",
              icon: "musical-notes",
              handler: () => {
                console.log("Play clicked: " + id);
                this.playSound(item);
              }
            },
            {
              text: "Verwijder",
              role: "destructive",
              icon: "trash",
              handler: () => {
                this.confirmDeleteAlert(item);
                console.log("Delete clicked: " + id);
              }
            },
            {
              text: "Cancel",
              icon: "close",
              role: "cancel",
              handler: () => {
                console.log("Cancel clicked: " + id);
              }
            }
          ]
        })
        .then(a => a.present());
    },
    presentGroupActionSheet(item) {
      let id = item.id;

      return this.$ionic.actionSheetController
        .create({
          header: "Bewerk",
          buttons: [
            {
              text: "Bewerk",
              icon: "create",
              handler: () => {
                let path = "/edit/" + id;
                this.$router.push({ path });
                console.log("Edit clicked: " + id);
              }
            },
            {
              text: "Bekijk Groep",
              icon: "folder-open",
              handler: () => {
                this.show = "items";
                this.showGroupID = id;
                console.log("Bekijk groep met: " + id);
              }
            },
            {
              text: "Voorbeeld",
              icon: "musical-notes",
              handler: () => {
                console.log("Play clicked: " + id);
                this.playSound(item);
              }
            },
            {
              text: "Verwijder",
              role: "destructive",
              icon: "trash",
              handler: () => {
                this.confirmDeleteAlert(item);
                console.log("Delete clicked: " + id);
              }
            },
            {
              text: "Cancel",
              icon: "close",
              role: "cancel",
              handler: () => {
                console.log("Cancel clicked: " + id);
              }
            }
          ]
        })
        .then(a => a.present());
    },
    confirmDeleteAlert(item) {
      return this.$ionic.alertController
        .create({
          header: "Verwijderen",
          message: "Weet je zeker dat je dit wilt verwijderen?",
          buttons: [
            {
              text: "Nee",
              role: "cancel",
              cssClass: "secondary",
              handler: blah => {
                console.log("Confirm Cancel:", blah);
              }
            },
            {
              text: "Ja",
              handler: () => {
                this.deleteItem(item);
                console.log("Confirm Okay");
              }
            }
          ]
        })
        .then(a => a.present());
    },
    deleteItem(item) {
      if (item.type === "item") {
        firebase
          .firestore()
          .collection("users")
          .doc(firebase.auth().currentUser.uid)
          .collection("items")
          .doc(item.id)
          .delete()
          .then(function() {
            console.log("Document successfully deleted!");
          })
          .catch(function(error) {
            console.error("Error removing document: ", error);
          });
      } else {
        this.confirmGroupDeleteAlert(item);
      }
      console.log(item.type);
    },
    deleteGroup(item) {
      let imageID = item.id;
      let vueElement = this;
      firebase
        .firestore()
        .collection("users")
        .doc(firebase.auth().currentUser.uid)
        .collection("items")
        .doc(item.id)
        .delete()
        .then(function() {
          console.log("Document successfully deleted!");
          vueElement.deleteImage(imageID);
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        });
      console.log(item.type);
    },
    deleteImage(imageID) {
      // Delete the file
      console.log("Deleting Image: " + imageID);
      storage
        .child("users/" + firebase.auth().currentUser.uid + "/items/" + imageID)
        .delete()
        .then(function() {
          // File deleted successfully
          console.log("Image Deleted Successfully");
        })
        .catch(function(error) {
          // Uh-oh, an error occurred!
          console.log("Error deleting image: " + error);
        });
    },
    confirmGroupDeleteAlert(item) {
      return this.$ionic.alertController
        .create({
          header: "Verwijderen",
          message:
            "Weet je zeker dat je een groep wilt verwijderen? Hierdoor raak je ook alle items binnen deze groep kwijt.",
          buttons: [
            {
              text: "Nee",
              role: "cancel",
              cssClass: "secondary",
              handler: blah => {
                console.log("Confirm Cancel:", blah);
              }
            },
            {
              text: "Ja",
              handler: () => {
                this.deleteGroup(item);
                console.log("Confirm Okay");
              }
            }
          ]
        })
        .then(a => a.present());
    }
  },
  created() {
    this.getItems();
  }
};
</script>
